import * as yup from "yup";
import { withExistingProfileTaxIdCheck, type ScheduleCheck } from "./utils";
import type { TaxIdType } from "~/graphql/supergraphTypes";

/**
 * Adds the debounced existing-profile tax-id check to a profile form's base
 * schema. Shared by the individual and entity wizard forms.
 */
export const addExistingProfileTaxIdCheck = (
  baseSchema: yup.AnyObjectSchema,
  params: { arenaAccessId?: number; taxIdType?: TaxIdType; scheduleCheck: ScheduleCheck },
): yup.AnyObjectSchema =>
  baseSchema.shape({
    taxId: withExistingProfileTaxIdCheck(
      yup.string().min(5, "Tax Id must be at least 5 characters"),
      params,
    ),
  });
